import { render, staticRenderFns } from "./MainDemo.vue?vue&type=template&id=1817a3fe&scoped=true&"
import script from "./MainDemo.vue?vue&type=script&lang=js&"
export * from "./MainDemo.vue?vue&type=script&lang=js&"
import style0 from "./MainDemo.vue?vue&type=style&index=0&id=1817a3fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817a3fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
